module.exports = __webpack_public_path__ + "img/computer_white.b9e03c86.svg";